export default "__VITE_ASSET__BxU054$Y__"